import { useMemo } from 'react';
import { useElementWidth } from '@/utils/useElementWidth';

interface UseVisibleColorsCountParams {
	itemSize: number;
	gap: number;
	totalItems: number;
}

export const useVisibleColorsCount = ({
	itemSize,
	gap,
	totalItems,
}: UseVisibleColorsCountParams) => {
	const { width: containerWidth, ref } = useElementWidth<HTMLDivElement>();

	const { visibleCount, overflowCount } = useMemo(() => {
		if (!containerWidth) {
			return { visibleCount: totalItems, overflowCount: 0 };
		}

		const maxFit = Math.max(0, Math.floor((containerWidth + gap) / (itemSize + gap)));

		if (maxFit >= totalItems) {
			return { visibleCount: totalItems, overflowCount: 0 };
		}

		const visibleDots = Math.max(0, maxFit - 1);

		return { visibleCount: visibleDots, overflowCount: totalItems - visibleDots };
	}, [containerWidth, itemSize, gap, totalItems]);

	return { ref, visibleCount, overflowCount };
};
